import React from 'react'
import { Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableHead from '@material-ui/core/TableHead'
import TableContainer from '@material-ui/core/TableContainer'
import CloseIcon from '@material-ui/icons/Close'
import OligoTableRow from './OligoTableRow'
import StyledTableCell from './StyledTableCell'
import useFormikHelper from '../useFormikHelper'

const useStyle = makeStyles((theme: Theme) => {
  return {
    closeIconStyle: {
      fontSize: theme.typography.pxToRem(12),
      cursor: 'pointer',
      fontWeight: 'bold',
      stroke: 'currentColor',
      strokeWidth: 2,
      marginLeft: theme.spacing(4),
    },
  }
})

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.grey,
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
  },
}))(TableRow)
const StandardTable = ({
  tableData,
  displayConcentrationColumn,
  handleCloseIconClick,
  handleEditIconClick,
  confirmOrderTableItems,
}) => {
  const classes = useStyle()
  const formik = useFormikHelper()
  const headerKeyMap = {
    SCALE: 'CONF_VIEWALL_SCALE',
    PURIFICATION: 'CONF_VIEWALL_PURIFICATION',
    FORMAT: 'CONF_SPECIFICATION_FORMAT_crisprgrna',
    TUBES: 'CONF_VIEWALL_TUBES',
    BASES: 'CONF_BASES',
  }
  return (
    <TableContainer>
      <Paper>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell
                style={{ paddingLeft: '24px' }}
                displayConcentrationColumn={displayConcentrationColumn}
              >
                <FormattedMessage
                  id="CONF_OLIGO_NAME_standard"
                  defaultMessage="Oligo Name"
                />
              </StyledTableCell>
              <StyledTableCell
                displayConcentrationColumn={displayConcentrationColumn}
              >
                <FormattedMessage id="SEQUENCE" defaultMessage="Sequence" />
              </StyledTableCell>
              {confirmOrderTableItems.map((item, index) => {
                return (
                  <StyledTableCell
                    displayConcentrationColumn={displayConcentrationColumn}
                    key={index}
                  >
                    <FormattedMessage
                      key={index}
                      id={
                        headerKeyMap[item.id.toUpperCase()] ||
                        item.id.toUpperCase()
                      }
                      defaultMessage={item.defaultMessage}
                    />
                  </StyledTableCell>
                )
              })}

              <StyledTableCell
                displayConcentrationColumn={displayConcentrationColumn}
                style={{ textAlign: 'right' }}
              >
                <FormattedMessage id="PRICE" defaultMessage="Price" />
              </StyledTableCell>
              <StyledTableCell
                displayConcentrationColumn={displayConcentrationColumn}
              >
                <CloseIcon
                  className={classes.closeIconStyle}
                  style={{
                    opacity: '0',
                    pointerEvents: 'none',
                    paddingLeft: 8,
                    paddingRight: 16,
                  }}
                />
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {tableData.map((oligo, index) => {
              return (
                <OligoTableRow
                  key={index}
                  oligo={oligo}
                  index={index}
                  displayConcentrationColumn={displayConcentrationColumn}
                  handleCloseIconClick={handleCloseIconClick}
                  handleEditIconClick={handleEditIconClick}
                  hasError={
                    !!formik.allValues.oligoList[index]?.listErrors?.length
                  }
                  hasWarning={
                    !!formik.allValues.oligoList[index]?.listWarning?.length
                  }
                />
              )
            })}
          </TableBody>
        </Table>
      </Paper>
    </TableContainer>
  )
}

export default StandardTable
